<div>
  <p-dialog
    #searchModal
    [(visible)]="isShowSearchModal"
    [maximizable]="true"
    [responsive]="true"
    [showHeader]="false"
    [draggable]="false"
    [resizable]="false"
    [transitionOptions]="'0ms'"
    (onShow)="initModalMaximized(searchModal)"
  >
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <!-- 헤더 시작 -->
      <!-- (input)="updateSearch($event)" -->
      <section class="header-modal">
        <div class="inner-search">
          <input type="search" #Keyword formControlName="keyword" [placeholder]="'SEARCH.SEARCH_TITLE' | t" />
          <a (click)="onClearSearch()"><img src="/assets/images/ico_search_cancel.svg" alt="search-cancel" /></a>
        </div>
        <a (click)="onCloseSearchModal()" class="button-close-search" [innerHTML]="'BUTTON.CANCEL' | t">Cancel</a>
        <!--
        <button (click)="onCloseSearchModal()" class="button-close-search" *ngIf="!isSearching">Cancel</button>
        <input type="submit" class="send active" *ngIf="isSearching" value="SEND" />
        -->
      </section>

      <!-- 검색 입력 전 노출 박스-->
      @if (!isSearching) {
        <section class="search-default-box">
          <ul class="tab-search-before">
            <li
              [class.active]="searchMode === SEARCH_MODE.RECENT"
              (click)="searchMode = SEARCH_MODE.RECENT"
              [innerHTML]="'SEARCH.RECENT' | t"
            >
              Recent
            </li>
            <li
              [class.active]="searchMode === SEARCH_MODE.TREND"
              (click)="searchMode = SEARCH_MODE.TREND"
              [innerHTML]="'SEARCH.TREND' | t"
            >
              Trend
            </li>
          </ul>
          <div class="list-recent" [class.active]="searchMode === SEARCH_MODE.RECENT">
            @if (recentSearches && recentSearches.length > 0) {
              <ul>
                @for (recentSearch of recentSearches; track recentSearch; let i = $index) {
                  <li>
                    <a (click)="onClickKeyword(recentSearch, false)">{{ recentSearch }}</a>
                    <button type="button" (click)="removeItems($event, i)">
                      <img src="/assets/images/btn_close01.svg" />
                    </button>
                  </li>
                }
                <div class="clear-all">
                  <span (click)="clearAllItems()" [innerHTML]="'BUTTON.CLEAR_ALL' | t">Clear All</span>
                </div>
              </ul>
            }
            <!-- 최근 리스트 없을 경우 노출되는 텍스트 -->
            @if (!recentSearches || recentSearches.length === 0) {
              <p class="text-nolist" [innerHTML]="'SEARCH.NOTHING' | t">
                There are no recent searches.<br />
                Search for a Product.
              </p>
            }
          </div>
          <div class="list-trend" [class.active]="searchMode === SEARCH_MODE.TREND">
            <ul>
              @for (popularSearch of popularSearches; track popularSearch; let i = $index) {
                <li>
                  <span [class.top3]="3 > i">{{ i + 1 }}</span>
                  <a (click)="onClickKeyword(popularSearch.keyword, true)">{{ popularSearch.keyword }}</a>
                </li>
              }
            </ul>
          </div>
        </section>
      }
      <!-- 검색 입력 동안 노출 박스-->
      @if (isSearching) {
        <section class="search-focus-box">
          @if (
            isSearchingLists &&
            isSearchingLists.length > 0 &&
            searchForm.get('keyword').value &&
            searchForm.get('keyword').value.length > 2
          ) {
            <ul>
              @for (brand of brandsType | slice: 0 : 3; track brand) {
                <li>
                  <span>{{ brand.searchType }}</span>
                  <!-- [routerLink]="['/brand', brand.item.id]" -->
                  <a
                    (click)="onCloseSearchModal(SEARCH_TYPE.BRAND, brand.item.id)"
                    [innerHTML]="brand.item.englishName | highlight: searchForm.get('keyword').value"
                    >{{ brand.item.englishName }}
                  </a>
                </li>
              }
              <!-- [routerLink]="['/product', product.item.id]"  -->
              @for (product of productType | slice: 0 : 10; track product; let i = $index) {
                <li
                  class="ga-ee-product-impression"
                >
                  <a
                    (click)="onCloseSearchModal(SEARCH_TYPE.PRODUCT, product.item.id)"
                    [innerHTML]="product.item.englishName | highlight: searchForm.get('keyword').value"
                    >{{ product.item.englishName }}
                  </a>
                </li>
              }
            </ul>
          }
          @if (!(brandsType && brandsType?.length) && !(productType && productType?.length)) {
            <div class="text-nolist">
              <span [innerHTML]="'SEARCH.NO_RESULT' | t"> No results that match your search. </span>
              @if (searchForm.get('keyword').value && searchForm.get('keyword').value.length >= 5) {
                <a [innerHTML]="'BUTTON.REQUEST_SUPPLY' | t" (click)="inquiry.open()">입고요청</a>
              }
            </div>
          }
        </section>
      }
    </form>
  </p-dialog>
</div>

<app-inquiry-mobile #inquiry [type]="INQUIRY_TYPE.PRODUCT" [isRequestProduct]="true"></app-inquiry-mobile>
